// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d0d03c01","732":"1ae1442f"}[chunkId] + ".chunk.js";
};